import { CaseGranulometry } from '../../CaseGranulometry';

export const getCasePropertyIndex = (
  caseGranulometry: CaseGranulometry,
  propertyName: string
): number => {
  return caseGranulometry.properties.findIndex((property) => property?.name === propertyName);
};
